import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "site-header" }
const _hoisted_3 = { class: "site-nav" }
const _hoisted_4 = { class: "nav-dropdown" }
const _hoisted_5 = { class: "nav-menu" }
const _hoisted_6 = { class: "page-shell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "background-layer",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "brand-link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "brand-mark" }, null, -1),
          _createTextVNode(" Henium ")
        ])),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Home")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/boozelog",
            class: "nav-parent"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Boozelog")
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/boozelog/support" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Support")
              ])),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/boozelog/privacy" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Privacy")
              ])),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_router_link, { to: "/decryptor" }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Decryption Utility")
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/contact" }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Contact")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("main", _hoisted_6, [
      _createVNode(_component_router_view)
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("footer", { class: "site-footer" }, [
      _createElementVNode("span", null, "Boozelog for mindful pacing and reflection.")
    ], -1))
  ]))
}